import { currency_options } from '@ninja/consts';

export default function getShortFormattedNumber(num, currency = null) {
  let currency_config = currency
    ? currency_options[currency.toUpperCase()]
    : window.currency_config;

  const formatter = new Intl.NumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
  });

  if (currency) {
    return currency_config.symbol + formatter.format(num);
  }

  return formatter.format(num);
}
